import { render, staticRenderFns } from "./GroupTemplateCharacterChoose.vue?vue&type=template&id=f0248fda&scoped=true"
import script from "./GroupTemplateCharacterChoose.vue?vue&type=script&lang=js"
export * from "./GroupTemplateCharacterChoose.vue?vue&type=script&lang=js"
import style0 from "./GroupTemplateCharacterChoose.vue?vue&type=style&index=0&id=f0248fda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0248fda",
  null
  
)

export default component.exports